<template>
  <template v-if="isAntiLeak">
    <AntiLeak @recover-layout="recoverLayout"></AntiLeak>
  </template>
  <template v-else-if="initialized === true">
    <component :is="layoutType"></component>
  </template>
</template>
<script>
import Vue from 'vue';
import AntiLeak from './views/anti-leak.vue';
export default {
  name: 'CeibaStatic',
  components: { AntiLeak },
  data() {
    return {
      initialized: false,
      layoutType: 'c-page-h5',
      isAntiLeak: true,
    };
  },
  computed: {
    canvasStyle() {
      return {
        background: '#ffffff',
      };
    },
  },
  async created() {
    const antiLeakStatus = JSON.parse(Vue.prototype.$actInfo.extend_config)?.antiLeak;
    //  antiLeakStatus：判断是否打开防泄密拦截
    //  Vue.prototype.$actInfo.ast：业务是否是商业化
    //  this.isAntiLeak：是否拦截标识
    console.log('process.env.VUE_APP_ACT_ENV', process.env.VUE_APP_ACT_ENV);
    if (
      antiLeakStatus
      && Vue.prototype.$actInfo.ast === 'commercial'
      && process.env.VUE_APP_ACT_ENV !== 'production'
    ) {
      this.isAntiLeak = true;
      this.$store.commit('UPDATE_ACTINFO', Vue.prototype.$actInfo);
      Vue.prototype.$storeInstance = this.$store;
    } else {
      this.isAntiLeak = false;
      this.initialize();
    }
  },
  methods: {
    initialize() {
      this.layoutType = Vue.prototype.$actInfo.layout_type;
      this.$store.commit('UPDATE_ACTINFO', Vue.prototype.$actInfo);
      Vue.prototype.$storeInstance = this.$store;
      this.initialized = true;
    },
    recoverLayout() {
      this.isAntiLeak = false;
      this.initialize();
    },
  },
};
</script>
